import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface QuillEditorToolbarComponentState {
    isDisabled: boolean;
    isTableFormatterAvailable: boolean;
    isFontColorFormatterAvailable: boolean;
    isLinkFormatterAvailable: boolean;
}

@Component({
    selector: "dtm-ui-quill-editor-toolbar",
    templateUrl: "./quill-toolbar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class QuillEditorToolbarComponent {
    @Input() public set isDisabled(value: BooleanInput) {
        this.localStore.patchState({ isDisabled: coerceBooleanProperty(value) });
    }

    @Input() public set isTableFormatterAvailable(value: BooleanInput) {
        this.localStore.patchState({ isTableFormatterAvailable: coerceBooleanProperty(value) });
    }

    @Input() public set isFontColorFormatterAvailable(value: BooleanInput) {
        this.localStore.patchState({ isFontColorFormatterAvailable: coerceBooleanProperty(value) });
    }

    @Input() public set isLinkFormatterAvailable(value: BooleanInput) {
        this.localStore.patchState({ isLinkFormatterAvailable: coerceBooleanProperty(value) });
    }

    protected isDisabled$ = this.localStore.selectByKey("isDisabled");
    protected isTableFormatterAvailable$ = this.localStore.selectByKey("isTableFormatterAvailable");
    protected isFontColorFormatterAvailable$ = this.localStore.selectByKey("isFontColorFormatterAvailable");
    protected isLinkFormatterAvailable$ = this.localStore.selectByKey("isLinkFormatterAvailable");

    constructor(private readonly localStore: LocalComponentStore<QuillEditorToolbarComponentState>) {
        this.localStore.setState({
            isDisabled: false,
            isTableFormatterAvailable: false,
            isFontColorFormatterAvailable: false,
            isLinkFormatterAvailable: false,
        });
    }
}
